import script from "./ExhibitDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ExhibitDetail.vue?vue&type=script&setup=true&lang=js"

import "./ExhibitDetail.vue?vue&type=style&index=0&id=53a0aa5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53a0aa5a"]])

export default __exports__